"use client";

import {
  DEFAULT_SHEET_FILTERS,
} from "libs/state/src/lib/stores/tanstack/filters/filters.config";
import {
  useFiltersStore,
} from "libs/state/src/lib/stores/tanstack/filters/useFiltersStore";

import type {
  TSheetDataFor,
  TSheetDataMap,
  TSheetOpenArgs,
  TUseSheets,
} from "./useSheets.config";

export const useSheets = <
  TSheet extends string,
  TDataMap extends TSheetDataMap<TSheet> = Record<never, never>,
>(): TUseSheets<TSheet, TDataMap> => {
  const { filters, replaceFilterGroup } = useFiltersStore();
  const [ activeSheet ] = Object.entries(filters.sheets);
  const data = activeSheet?.[1].data ?? null;

  const isOpen = (key: TSheet) => activeSheet?.[0] === key;

  const getData = <TKey extends TSheet>(
    key: TKey,
  ): TSheetDataFor<TSheet, TDataMap, TKey> | null => isOpen(key)
    ? data as TSheetDataFor<TSheet, TDataMap, TKey>
    : null;

  const onOpen = <TKey extends TSheet>(
    key: TKey,
    ...[ sheetData ]: TSheetOpenArgs<TSheet, TDataMap, TKey>
  ) => {
    replaceFilterGroup("sheets", {
      [key]: {
        data: sheetData ?? {},
      },
    });
  };

  const onClose = () => replaceFilterGroup("sheets", DEFAULT_SHEET_FILTERS);

  return {
    data,
    getData,
    isOpen,
    onOpen,
    onClose,
  };
};
